/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: ea99bacb (Fri Jun  5 23:34:18 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
  FetchUserScreeningsResponse,
  FetchUserScreeningsResponseFromJSON,
  OK1,
  OK1FromJSON,
  UpdateUserScreeningRequestBody,
  UpdateUserScreeningRequestBodyToJSON,
} from '../models'
import * as runtime from '../runtime'

export interface FetchUserScreeningsRequest
  extends runtime.BaseRequestParameters {
  page?: number
  pageSize?: number
  orderBy?: Array<string>
  userEmail?: string
  status?: FetchUserScreeningsStatusEnum
  screeningType?: FetchUserScreeningsScreeningTypeEnum
}

export interface UpdateUserScreeningRequest
  extends runtime.BaseRequestParameters {
  body: UpdateUserScreeningRequestBody
}

/**
 * ScreeningApi - interface
 *
 * @export
 * @interface ScreeningApiInterface
 */
export interface ScreeningApiInterface {
  /**
   * Retrieves information about invited users and their status regarding background checks and safety training. This data will be used by our legal staff to manually manage statuses under certain conditions.
   * @summary Returns information for all records in userScreening table.
   * @param {number} [page] The current page of data to be returned. Must be at least 1.
   * @param {number} [pageSize] The length of data to be returned on the requested page. Must be at least 1
   * @param {Array<string>} [orderBy] The order by properties and direction for the data in the endpoint. See endpoint description for what is applicable. Must be in a format like: \&#39;property ASC\&#39;
   * @param {string} [userEmail] Filters the response of the fetchUserScreenings endpoint by the user\&#39;s email.
   * @param {'Requested' | 'In-Review' | 'Approved' | 'Approved (manual)' | 'Declined' | 'Declined (manual)' | 'Creation Pending' | 'Processing' | 'Cancelled'} [status]
   * @param {'Background Check' | 'Safety Training'} [screeningType] Filters the response of the fetchUserScreenings endpoint based on the screening type.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ScreeningApiInterface
   */
  fetchUserScreeningsRaw(
    requestParameters: FetchUserScreeningsRequest
  ): Promise<runtime.ApiResponse<FetchUserScreeningsResponse>>

  /**
   * Retrieves information about invited users and their status regarding background checks and safety training. This data will be used by our legal staff to manually manage statuses under certain conditions.
   * Returns information for all records in userScreening table.
   */
  fetchUserScreenings(
    requestParameters: FetchUserScreeningsRequest
  ): Promise<FetchUserScreeningsResponse>

  /**
   * Update status of an userScreening record.
   * @summary Update an existing userScreening record.
   * @param {UpdateUserScreeningRequestBody} updateUserScreeningRequestBody An object containing fields to update on a UserScreening record.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ScreeningApiInterface
   */
  updateUserScreeningRaw(
    requestParameters: UpdateUserScreeningRequest
  ): Promise<runtime.ApiResponse<OK1>>

  /**
   * Update status of an userScreening record.
   * Update an existing userScreening record.
   */
  updateUserScreening(
    requestParameters: UpdateUserScreeningRequest
  ): Promise<OK1>
}

/**
 *
 */
export class ScreeningApi
  extends runtime.BaseAPI
  implements ScreeningApiInterface
{
  /**
   * Retrieves information about invited users and their status regarding background checks and safety training. This data will be used by our legal staff to manually manage statuses under certain conditions.
   * Returns information for all records in userScreening table.
   */
  async fetchUserScreeningsRaw(
    requestParameters: FetchUserScreeningsRequest
  ): Promise<runtime.ApiResponse<FetchUserScreeningsResponse>> {
    const queryParameters: any = {}

    if (requestParameters.page !== undefined) {
      queryParameters['page'] = requestParameters.page
    }

    if (requestParameters.pageSize !== undefined) {
      queryParameters['pageSize'] = requestParameters.pageSize
    }

    if (requestParameters.orderBy) {
      queryParameters['orderBy'] = requestParameters.orderBy
    }

    if (requestParameters.userEmail !== undefined) {
      queryParameters['userEmail'] = requestParameters.userEmail
    }

    if (requestParameters.status !== undefined) {
      queryParameters['status'] = requestParameters.status
    }

    if (requestParameters.screeningType !== undefined) {
      queryParameters['screeningType'] = requestParameters.screeningType
    }

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/userScreening`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FetchUserScreeningsResponseFromJSON(jsonValue)
    )
  }

  /**
   * Retrieves information about invited users and their status regarding background checks and safety training. This data will be used by our legal staff to manually manage statuses under certain conditions.
   * Returns information for all records in userScreening table.
   */
  async fetchUserScreenings(
    requestParameters?: FetchUserScreeningsRequest
  ): Promise<FetchUserScreeningsResponse> {
    const response = await this.fetchUserScreeningsRaw(requestParameters || {})
    return await response.value()
  }

  /**
   * Update status of an userScreening record.
   * Update an existing userScreening record.
   */
  async updateUserScreeningRaw(
    requestParameters: UpdateUserScreeningRequest
  ): Promise<runtime.ApiResponse<OK1>> {
    if (
      requestParameters.body === null ||
      requestParameters.body === undefined
    ) {
      throw new runtime.RequiredError(
        'body',
        'Required parameter requestParameters.body was null or undefined when calling updateUserScreening.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/userScreening`,
      method: 'PATCH',
      headers: headerParameters,
      query: queryParameters,
      body: UpdateUserScreeningRequestBodyToJSON(requestParameters.body),
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      OK1FromJSON(jsonValue)
    )
  }

  /**
   * Update status of an userScreening record.
   * Update an existing userScreening record.
   */
  async updateUserScreening(
    requestParameters: UpdateUserScreeningRequest
  ): Promise<OK1> {
    const response = await this.updateUserScreeningRaw(requestParameters)
    return await response.value()
  }
}

/**
 * @export
 * @enum {string}
 */
export enum FetchUserScreeningsStatusEnum {
  Requested = 'Requested',
  InReview = 'In-Review',
  Approved = 'Approved',
  ApprovedManual = 'Approved (manual)',
  Declined = 'Declined',
  DeclinedManual = 'Declined (manual)',
  CreationPending = 'Creation Pending',
  Processing = 'Processing',
  Cancelled = 'Cancelled',
}
/**
 * @export
 * @enum {string}
 */
export enum FetchUserScreeningsScreeningTypeEnum {
  BackgroundCheck = 'Background Check',
  SafetyTraining = 'Safety Training',
}
